import React, { useState } from 'react';
import { updateDoc, doc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { creerDevis } from '../services/accountingService';
import DevisModalBase from './DevisModalBase';

/**
 * Modal de création de devis - Version compacte utilisant DevisModalBase
 */
const CreateDevisModal = ({ onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  // Gestionnaire de création de devis
  const handleCreateDevis = async (devisData) => {
    const { selectedClient, lignesPrestations, contratParams, periodePrestation, preview } = devisData;

    if (!selectedClient || !preview) {
      alert('Veuillez sélectionner un client et vérifier les calculs');
      return;
    }

    setLoading(true);
    try {
      const result = await creerDevis(
        db,
        contratParams,
        lignesPrestations,
        selectedClient,
        {
          userId: 'current-user', // À remplacer par l'ID utilisateur actuel
          notes: `Devis créé depuis l'interface - ${lignesPrestations.length} prestations`,
          conditionsPaiement: 'Paiement à 30 jours fin de mois',
          dateDebut: periodePrestation?.dateDebut ? Timestamp.fromDate(periodePrestation.dateDebut) : null,
          dateFin: periodePrestation?.dateFin ? Timestamp.fromDate(periodePrestation.dateFin) : null
        }
      );

      alert(`✅ Devis ${result.numero} créé avec succès !`);
      onSuccess && onSuccess(result);
      onClose();
    } catch (error) {
      console.error('Erreur création devis:', error);
      alert('❌ Erreur lors de la création du devis');
    } finally {
      setLoading(false);
    }
  };

  return (
    <DevisModalBase
      mode="create"
      onClose={onClose}
      onSuccess={onSuccess}
      title="Créer un nouveau devis"
      subtitle="Configurez les prestations et générez un devis avec les tarifs OMAD"
      actionLabel={loading ? "Création..." : "Créer le devis"}
      onAction={handleCreateDevis}
      loading={loading}
    />
  );
};

export default CreateDevisModal;
